/**
 * Retype effect for an attribute or innerHTML of an element
 *
 * @param targetElement
 * @param words
 * @param targetAttribute
 */
export function retyping(targetElement: HTMLElement, words: string|string[], targetAttribute: string = null, prefix: string = '') {
    const init = async () => {
        if (targetAttribute !== null) {
            targetElement.setAttribute(targetAttribute, '');
        } else {
            targetElement.innerHTML = '';
        }

        if (typeof words === 'string') {
            words = words.split(',');
        }

        let i = 0;
        let timer;

        function typingEffect() {
            let word = words[i].split("");
            let init = false;

            const loopTyping = function () {
                if (!init) {
                    if (targetAttribute === null) {
                        targetElement.innerHTML = prefix;
                    } else {
                        targetElement.setAttribute(targetAttribute, prefix);
                    }

                    init = true;
                }

                if (word.length > 0) {
                    if (targetAttribute === null) {
                        targetElement.innerHTML += word.shift();
                        return;
                    }

                    targetElement.setAttribute(targetAttribute, targetElement.getAttribute(targetAttribute) + word.shift());
                } else {
                    deletingEffect();
                    return false;
                }

                timer = setTimeout(loopTyping, 200);
            };
            loopTyping();
        }

        function deletingEffect() {
            let word = words[i].split("");

            const loopDeleting = function () {
                if (word.length > 0) {
                    word.pop();

                    if (targetAttribute === null) {
                        targetElement.innerHTML = prefix + word.join("");
                        return;
                    }

                    targetElement.setAttribute(targetAttribute, prefix + word.join(""));
                } else {
                    if (words.length > (i + 1)) {
                        i++;
                    } else {
                        i = 0;
                    }

                    typingEffect();
                    return false;
                }

                timer = setTimeout(loopDeleting, 100);
            };
            loopDeleting();
        }

        typingEffect();
    }

    init();
}
